import React, { useEffect } from "react";
import EditUsers from "./EditUsers.js";
import Axios from "axios";
import { generalErrors } from "../../consts/ErrorMessages.js";
import TableUsers from "./TableUsers";
import { Switch, Route, useRouteMatch, withRouter } from "react-router-dom";
import { usersParserFromServer, setUsersInitState } from "./Helper";
import "../../styles/css/App.css";
import * as Constants from "../../consts/Constants.js";
import Alert from "../../components/common/SnackAlert.js";

function Users({ history }) {
  let { path, url } = useRouteMatch();

  const [alertOpen, setAlertOpen] = React.useState(false);
  const [entries, setEntries] = React.useState({
    data: [],
  });
  const [roles, setRoles] = React.useState([]);
  const [inputsForm, setInputsForm] = React.useState({});

  const handleClickOpen = (event, rowData) => {
    if (rowData !== undefined) {
      setInputsForm(usersParserFromServer(rowData));
      history.push(`${url}/form`);
    } else {
      history.push(`${url}/form`);
    }
  };

  const handleCleaner = (e) => {
    setInputsForm(setUsersInitState());
  };

  const handleClose = () => {
    handleCleaner();
    history.goBack();
  };

  const handlePrimaryRoleChange = (e, rowData) => {
    const { value } = e.target;
    let url = Constants.FINAL_URL_USERS + rowData.userId + "/role";
    Axios.put(url, value, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status === Constants.RESPONSE_OK) {
          let newRow = { ...rowData, role: value };
          let newEntries = [];
          entries.data.map((dataItem) => {
            dataItem.userId == rowData.userId
              ? newEntries.push(newRow)
              : newEntries.push(dataItem);
          });
          setEntries({ data: newEntries });
        } else {
          setAlertOpen(true);
        }
      })
      .catch(() => {
        setAlertOpen(true);
      });
  };

  const handleSecondaryRolesChange = (
    userId,
    oldSecondaryRoles,
    newSecondaryRoles
  ) => {
    //Busco roles para agregar
    let addRoles = newSecondaryRoles.filter(
      (value) => oldSecondaryRoles.indexOf(value) === -1
    );

    //Busco roles para eliminar
    let deleteRoles = oldSecondaryRoles.filter(
      (value) => newSecondaryRoles.indexOf(value) === -1
    );

    var oldAuth = JSON.parse(localStorage.getItem("auth"));

    let url = Constants.FINAL_URL_USERS + userId + "/role";
    for (let i = 0; i < addRoles.length; i++) {
      let value = addRoles[i];
      fetch(url, {
        method: "POST",
        body: value,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + oldAuth.token,
        },
      })
        .then((response) => {
          if (response.status !== Constants.RESPONSE_OK) {
            setAlertOpen(true);
          }
        })
        .catch(() => {
          setAlertOpen(true);
        })
        .finally(() => {
          if (deleteRoles.length == 0 && addRoles.length === i + 1) {
            getUsers();
          }
        });
    }

    for (let i = 0; i < deleteRoles.length; i++) {
      let value = deleteRoles[i];
      fetch(url, {
        method: "DELETE",
        body: value,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + oldAuth.token,
        },
      })
        .then((response) => {
          if (response.status !== Constants.RESPONSE_OK) setAlertOpen(true);
        })
        .catch(() => {
          setAlertOpen(true);
        })
        .finally(() => {
          if (deleteRoles.length === i + 1) {
            getUsers();
          }
        });
    }
  };

  const getUsers = () => {
    let source = Axios.CancelToken.source();
    Axios.get(Constants.FINAL_URL_USERS, {
      cancelToken: source.token,
    })
      .then((response) => {
        let data = [];
        response.data.forEach((usersItem) => {
          data.push(usersItem);
        });
        setEntries({ data: data });
      })
      .catch(() => {
        setAlertOpen(true);
      });
    return () => source.cancel();
  };

  const getRoles = () => {
    let source = Axios.CancelToken.source();
    Axios.get(Constants.FINAL_URL_ROLES + "?mainRole=true&assignable=true", {
      cancelToken: source.token,
    })
      .then((response) => {
        let data = [];
        response.data.forEach((roleItem) => {
          data.push(roleItem);
        });
        setRoles(data);
      })
      .catch(function () {});
    return () => source.cancel();
  };

  useEffect(() => {
    getUsers();
    getRoles();
  }, []);

  return (
    <Switch>
      <Route exact path={path}>
        <TableUsers
          {...{
            handleClickOpen,
            entries,
            roles,
            handlePrimaryRoleChange,
          }}
        />
        <Alert
          open={alertOpen}
          setOpen={setAlertOpen}
          mensaje={generalErrors.server}
          severity="error"
        ></Alert>
      </Route>
      <Route exact path={`${path}/form`}>
        <EditUsers
          {...{
            handleClose,
            inputsForm,
            roles,
            handlePrimaryRoleChange,
            setInputsForm,
            alertOpen,
            setAlertOpen,
            handleSecondaryRolesChange,
          }}
        />
      </Route>
    </Switch>
  );
}

export default withRouter(Users);
